export default "__VITE_ASSET__3UrFE7hl__"